export const SET_HOSTED_FROM_ADDRESS = 'SET_HOSTED_FROM_ADDRESS';
export const SET_CAN_SHOW_SUSPENSION_ALERT = 'SET_CAN_SHOW_SUSPENSION_ALERT';